import { fireGtagEvent } from '../helpers/gtag-helpers'
import { createRecitTracker } from '../../analytics/create-tracker';

const IMPRESSION_EVENT = 0;
const CLICK_EVENT = 1;
const ANALYTICS_VIEW_NAME = 'syndicated_rec_test';

const trackRecitImpression = createRecitTracker('pv_wt', ANALYTICS_VIEW_NAME, IMPRESSION_EVENT);
const trackRecitClick = createRecitTracker('pv_wt', ANALYTICS_VIEW_NAME, CLICK_EVENT);

/**
 * Catalog of analytics events triggered from Syndication features.
 * Provides a clean interface for describing the tracking events.
 */

export default {
  synArticleClickShareFacebook: () => fireGtagEvent('Clicked Share Button', "Facebook", 'Storypage'),
  synArticleClickShareTwitter: () => fireGtagEvent('Clicked Share Button', "Twitter", 'Storypage'),
  synArticleClickShareEmail: () => fireGtagEvent('Clicked Share Button', "Email", 'Storypage'),
  recitImpression: (
      cxt_model,
      cxt_rec_id,
      cxt_page_load_id,
      cxt_synd_id,
      cxt_module,
      cxt_position,
      cxt_rec_item_id,
  ) => {
    const time = Math.round(new Date() / 1000); // unix timestamp

    return trackRecitImpression(
        cxt_model,
        time,
        cxt_rec_id,
        cxt_page_load_id,
        cxt_synd_id,
        cxt_module,
        cxt_position,
        cxt_rec_item_id,
    )
  },
  recitClick: (
      cxt_model,
      cxt_rec_id,
      cxt_page_load_id,
      cxt_synd_id,
      cxt_module,
      cxt_position,
      cxt_rec_item_id,
  ) => {
    const time = Math.round(new Date() / 1000); // unix timestamp

    return trackRecitClick(
        cxt_model,
        time,
        cxt_rec_id,
        cxt_page_load_id,
        cxt_synd_id,
        cxt_module,
        cxt_position,
        cxt_rec_item_id,
    )
  }
};
